import { Ripple } from "@/shared/ui/Ripple";

export class NotificationPermissionPopup {
    public static show(
        message: string,
        confirmHandler?: { () },
        deniedHandler?: { () },
        confirmButton?: string,
        cancelButton?: string,
        uniqueId?: string,
        highlightConfirm?: boolean,
        highlightCancel?: boolean,
        confirmBtnOnTheLeft?: boolean
    ) {
        const parent = $(".app");

        if (uniqueId !== undefined) {
            if (parent.find(".popup." + uniqueId).length !== 0) return;
        }

        //dim background
        let dim = parent.find("> .dim.popupdim");
        if (dim.length === 0) dim = $('<div class="dim popupdim" />').appendTo(parent);
        else dim.stop(true, false);

        dim[0].offsetHeight;
        dim.addClass("shown");

        const msg = $(
            '<div class="popup' +
                (uniqueId === undefined ? "" : " " + uniqueId) +
                '"><div class="text">' +
                message +
                "</div></div>"
        ).appendTo(parent);

        const btns = $('<div class="btns" />').appendTo(msg);

        if (confirmBtnOnTheLeft === true) {
            if (cancelButton !== undefined) {
                this.addCancelButton(btns, deniedHandler, highlightConfirm, cancelButton, highlightCancel);
                btns.addClass("split");
            }

            this.addConfirmButton(btns, confirmHandler, confirmButton, highlightConfirm);
        } else {
            this.addConfirmButton(btns, confirmHandler, confirmButton, highlightConfirm);

            if (cancelButton !== undefined) {
                btns.addClass("split");
                this.addCancelButton(btns, deniedHandler, highlightConfirm, cancelButton, highlightCancel);
            }
        }

        msg[0].offsetHeight;
        msg.css("margin-top", (msg.height() + 60) / -2);
        msg.addClass("shown");
    }

    private static addCancelButton(
        buttonsContainer: JQuery,
        deniedHandler?: { () },
        highlightConfirm?: boolean,
        cancelButton?: string,
        highlightCancel?: boolean
    ) {
        Ripple.bind(
            $(
                '<button class="btn ' +
                    (highlightCancel === true ? "orange" : highlightConfirm === true ? "" : "secondary") +
                    '">' +
                    cancelButton +
                    "</button>"
            )
                .appendTo(buttonsContainer)
                .click((e) => {
                    e.preventDefault();

                    if (deniedHandler !== undefined) {
                        deniedHandler();
                    }
                    NotificationPermissionPopup.close($(e.currentTarget).parent().parent());
                })
        );
    }

    private static addConfirmButton(
        buttonsContainer: JQuery,
        confirmHandler?: { () },
        confirmButton?: string,
        highlightConfirm?: boolean
    ) {
        Ripple.bind(
            $(
                '<button class="btn confirm ' +
                    (highlightConfirm !== undefined && highlightConfirm === true ? "orange" : "") +
                    '">' +
                    (confirmButton === undefined ? "Ok" : confirmButton) +
                    "</button>"
            )
                .appendTo(buttonsContainer)
                .click(async (e) => {
                    const permission = await Notification.requestPermission();
                    if (permission === "granted") {
                        console.log("Notification permission granted.");
                    } else {
                        console.log("Unable to get permission to notify.");
                    }
                    if (confirmHandler !== undefined) {
                        confirmHandler();
                    }
                    NotificationPermissionPopup.close($(e.currentTarget).parent().parent());

                    e.preventDefault();
                })
        );
    }

    private static close($popup: JQuery) {
        $popup.addClass("closing")[0].offsetHeight;
        const totalPopups = $(".app > .popup").length;

        $popup
            .removeClass("shown")
            .delay(600)
            .queue((e) => {
                $popup.remove();
                e();
            });

        //check if dim needs to be removed
        if (totalPopups <= 1) {
            const dim = $(".app > .dim.popupdim")
                .delay(250)
                .queue((c) => {
                    dim.removeClass("shown")
                        .delay(350)
                        .queue((a) => {
                            dim.remove();
                            a();
                        });

                    c();
                });
        }
    }
}
